'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    button: (0, _functional.getElement)('.js-ReadMore_Button', { context: el }),
    lessButton: (0, _functional.getElement)('.js-ReadLess_Button', { context: el }),
    container: (0, _functional.getElement)('.js-ReadMore_Container', { context: el })
  };

  if (this.els.container.offsetHeight > 120) {
    this.els.container.classList.add('js-ReadMore_Active');
    this.els.button.classList.add('js-ReadMore_Active');
    this.els.lessButton.classList.remove('js-ReadMore_Active');

    this.els.button.addEventListener('click', function () {
      _this.els.container.classList.remove('js-ReadMore_Active');
      _this.els.button.classList.remove('js-ReadMore_Active');
      _this.els.lessButton.classList.add('js-ReadMore_Active');
    });

    this.els.lessButton.addEventListener('click', function () {
      _this.els.container.classList.add('js-ReadMore_Active');
      _this.els.button.classList.add('js-ReadMore_Active');
      _this.els.lessButton.classList.remove('js-ReadMore_Active');
    });
  }
};

exports.default = _class;